import { KeyValuePair } from "utilities/objects";
import { DowngradeTypeBE, DowngradeTypeFE } from "./";

export interface FETierSetFormat {
  translations: {
    name?: string;
    description?: string;
    code?: string;
  }[];
  active: boolean;
  labels?: KeyValuePair[];
  conditions: {
    walletType?: string;
    eventName?: string;
    attribute: string;
  }[];
  downgrade: DowngradeTypeFE;
  isMigrated?: boolean;
}

export type BETierSetFormat = Omit<
  FETierSetFormat,
  "translations" | "downgrade"
> & {
  translations: {
    [key: string]: {
      name?: string;
      description?: string;
    };
  };
  downgrade: DowngradeTypeBE;
};

export enum TierType {
  TIER_SET = "custom",
  SINGLE_TIER = "traditional",
}

export interface TierSetType {
  tierSetId: string;
  name: string;
  description: string;
  translations: {
    [key: string]: {
      description: string;
      name: string;
    };
  };
  active: boolean;
  labels: KeyValuePair[];
  conditions: {
    walletType?: string;
    id?: string;
    attribute: string;
    eventName?: string;
  }[];
  downgrade: {
    mode: "none" | "automatic" | "periodic";
  };
  isMigrated?: boolean;
  tiers: {
    active: boolean;
    name: string;
    description?: string;
    levelId: string;
  }[];
}
